import { lazy, memo, ReactNode, useEffect, useRef } from 'react';
import { OnboardingContextProvider } from '../flows/onboarding/OnboardingContext';
import {
  LaunchTrackBeginSpan,
  LaunchTrackEndSpan,
} from '../functions/appLaunchTracking';
import { useClearGuestUser } from '../functions/user/useClearGuestUser';
import { onErrorIgnore } from '../utils/onErrorIgnore';
import { EnsureFirebaseInitialized } from './EnsureFirebaseInitialized';

const EnsureFontLoadedFull = lazy(() => import('../components/styles/fonts'));

export const EnsureAppReady = memo(({ children }: { children: ReactNode }) => {
  // need to ensure all fonts loaded before rendering the app for psl
  return (
    <EnsureFontLoadedFull>
      <Content>{children}</Content>
    </EnsureFontLoadedFull>
  );
});

const Content = memo(({ children }: { children?: ReactNode }) => {
  return (
    <EnsureFirebaseInitialized>
      <LaunchTrackBeginSpan name="onboarding-context">
        <OnboardingContextProvider>
          <LaunchTrackEndSpan name="onboarding-context">
            <EnsureGuestUserCleared />
            {children}
          </LaunchTrackEndSpan>
        </OnboardingContextProvider>
      </LaunchTrackBeginSpan>
    </EnsureFirebaseInitialized>
  );
});

const EnsureGuestUserCleared = memo(() => {
  const cleared = useRef(false);
  const clearGuestUser = useClearGuestUser();
  useEffect(() => {
    if (cleared.current) {
      return;
    }
    clearGuestUser()
      .catch(onErrorIgnore)
      .finally(() => {
        cleared.current = true;
      });
  }, [clearGuestUser]);
  return null;
});
